export default () => {
  return document.location.search || '';
};
